import { createStatusColorLookup } from '@/utils/statusColorLookup';

const DECISION_STATUS_COLORS = {
  accepted: 'success',
  pending: 'warning',
  declined: 'error',
} as const;

export const getDecisionStatusColor = createStatusColorLookup(
  DECISION_STATUS_COLORS,
);
